import React, {ComponentType, createContext, FC, PropsWithChildren, useContext} from 'react';
import {Diff} from 'utility-types';

/*
 * Props.
 */

export interface GrammarlyContextProps {
  composerHeight?: number;
  rightSidebarWidth?: number;
  scrollbarWidth?: number;
  shouldGrammarlySuggestionOpen?: boolean;
  setRightSidebarWidth: (arg: number) => void;
  setComposerHeight: (arg: number) => void;
  setScrollbarWidth: (arg: number) => void;
  setShouldGrammarlySuggestionOpen: (arg: boolean) => void;
}

/*
 * Context.
 */

export const GrammarlyContext = createContext<GrammarlyContextProps>({
  setRightSidebarWidth: () => {},
  setComposerHeight: () => {},
  setScrollbarWidth: () => {},
  setShouldGrammarlySuggestionOpen: () => {},
});

/*
 * HOC.
 */

export function withGrammarlyState<T extends object>(
  Component: ComponentType<PropsWithChildren<T & GrammarlyContextProps>>,
): FC<PropsWithChildren<Diff<T, GrammarlyContextProps>>> {
  return function (props) {
    return (
      <GrammarlyContext.Consumer>
        {(context) => <Component {...(props as any)} {...context} />}
      </GrammarlyContext.Consumer>
    );
  };
}

/*
 * Hook.
 */

export function useGrammarlyState() {
  return useContext(GrammarlyContext);
}
